import { useEffect, useState } from "react"

import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import NotificationOptions from "./NotificationOptions"
import NotificationOptionsData from "../../../api/Notifications/Model/NotificationOptionsData"
import NotificationSectionProps from "../../../api/Notifications/Model/NotificationSectionProps"
import { NotificationServicesGet } from "../../../api/Notifications/NotificationDetailGet"
import FormatError from "../../../formatters/FormatError"

interface NotificationServiceSelectionProps extends NotificationSectionProps {
  participationId?: number
}

function NotificationServiceSelection(props: NotificationServiceSelectionProps) {
  const { participationId, selectedIDs, onChange } = props

  const [loading, setLoading] = useState(false)
  const [notificationServices, setNotificationServices] = useState<NotificationOptionsData[]>([])

  useEffect(() => {
    setLoading(true)
    const subscription = NotificationServicesGet(participationId)
      .pipe(finalize(() => setLoading(false)))
      .subscribe(
        (data) =>
          setNotificationServices(
            data.map((method) => ({
              Id: method.ServiceID,
              Code: method.ServiceCode,
              Description: method.ServiceDescription,
            }))
          ),
        (error) => toast.error(FormatError(error))
      )
    return () => subscription?.unsubscribe()
  }, [participationId])

  return (
    <NotificationOptions
      items={notificationServices}
      selectedIDs={selectedIDs}
      loading={loading}
      onChange={onChange}
      description="Services"
    />
  )
}

NotificationServiceSelection.defaultProps = {
  participationId: undefined,
}

export default NotificationServiceSelection
